import InboxListMail from "./InboxListMail.js";
import InboxMobileListMail from "./InboxMobileListMail.js";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import { useAppSelector } from "store/hooks.ts";
import { selectMailsData } from "store/selectors/inboxSelectors.ts";

const InboxMailsContainer = ({ setShowSideBar, all, trash }) => {
  const mailsData = useAppSelector(selectMailsData);
  const { mobileCondition } = useMediaQueries();

  return (
    <>
      {Object.keys(mailsData || {}).map((item, index) => {
        return mobileCondition ? (
          <InboxMobileListMail
            key={item}
            data={mailsData?.[item]}
            setShowSideBar={setShowSideBar}
          />
        ) : (
          <InboxListMail
            key={item}
            data={mailsData?.[item]}
            index={index}
            all={all}
            trash={trash}
          />
        );
      })}
    </>
  );
};

export default InboxMailsContainer;
